export default function getCustomerKeyFromUrl({ customerFromPath }) {
  const hashKey = (window.location.hash || "").replace("#", "").trim();
  if (hashKey) return hashKey;

  const params = new URLSearchParams(window.location.search);
  const slugKey = (params.get("slug") || "").trim();
  if (slugKey) return slugKey;
  const qpKey = (params.get("customer") || "").trim();
  if (qpKey) return qpKey;

  return customerFromPath || null;
}
